
import React from 'react';
import Hero from '@/components/Hero';
import SEOMetadata from '@/components/common/SEOMetadata';
import { Helmet } from 'react-helmet-async';

// Import refactored components
import PressResourcesCard from '@/components/press-kit/PressResourcesCard';
import AboutSection from '@/components/press-kit/AboutSection';
import MediaContact from '@/components/press-kit/MediaContact';
import FAQSection from '@/components/press-kit/FAQSection';
import TestimonialsSection from '@/components/press-kit/TestimonialsSection';
import { faqs } from '@/components/press-kit/constants';

const PressKit = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F7F0DE] to-white">
      <SEOMetadata
        title="Press Kit | Cats About Town Tours"
        description="Logos, tour photos, press releases and media resources for Cats About Town Tours."
        canonicalUrl="https://catsabouttowntours.com/press-kit"
        keywords={[
          'press kit',
          'Cats About Town Tours media',
          'tour photos',
          'press release'
        ]}
      />

      {/* Hero Section - More modern approach */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-[#894D1D]/10 to-[#698235]/10"></div>
        <div className="relative">
          <Hero
            title="Press Kit"
            subtitle="Everything you need to cover Cats About Town Tours: logos, tour photos, press releases, booking links, and media contact info."
            backgroundImage="/lovable-uploads/catsabouttowntours_1738852061_3562071727167250228_67182239447.jpg"
            height="medium"
            imageStyle="natural"
            backgroundAlt="Press materials for Cats About Town Tours"
            overlay={true}
            overlayOpacity="light"
          />
        </div>
      </div>

      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://catsabouttowntours.com/' },
              { '@type': 'ListItem', position: 2, name: 'Press Kit', item: 'https://catsabouttowntours.com/press-kit' }
            ]
          })}
        </script>
      </Helmet>

      {/* Main Content with better spacing */}
      <div className="relative -mt-16 z-10">
        <div className="container mx-auto px-4 md:px-8 space-y-20">
          {/* Press Resource Link */}
          <PressResourcesCard />
          
          {/* About Section */}
          <AboutSection />
          
          {/* Media Contact */}
          <MediaContact />
          
          {/* FAQs */}
          <FAQSection faqs={faqs} />
          
          {/* Testimonials */}
          <TestimonialsSection />
        </div>
      </div>
    </div>
  );
};

export default PressKit;
